import { useSelector } from 'react-redux';

import { makeGetProject } from 'selectors/projects';

const getProject = makeGetProject();

export const useProject = projectId => {
    const project = useSelector(({ projects }) => projectId ? getProject(projects.items, projectId) : null);

    return project;
};

export const useProjectModuleDisabled = (projectId, moduleName) => {
    const project = useProject(projectId);

    return (project?.disabled_modules || []).includes(moduleName);
};

export const useProjectHasAutoMilestones = projectId => {
    const project = useProject(projectId);

    return Boolean(project?.auto_milestones);
}
